import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_APPROVE_STAFF,API_REJECT_STAFF, API_CREATE_STAFF, API_CREATE_STAFF_SALARY_INFO, API_DELETE_STAFF, API_GET_ALL_STAFF_LIST, API_GET_STAFF_LIST, API_GET_STAFF_SALARY_INFO, API_GET_STAFF_LOP_LIST, API_STAFF_BULK_IMPORT, API_UPDATE_STAFF, API_UPDATE_STAFF_SALARY_INFO, API_UPSERT_STAFF_LOP } from "../../../shared/routes/private.routes";

const config = {
  name: "staff",
};
export const getStaffList: any = createAsyncThunk(
  `${config.name}/getStaffList`,
  async ({params, body}: any) => {
    const result = await Client.post(API_GET_STAFF_LIST, body, {params});
    return result?.data
  }
);

export const createStaff: any = createAsyncThunk(
  `${config.name}/create-staff`,
  async (formData: FormData) => {
    return Client.post(API_CREATE_STAFF, formData);
  }
);

export const staffBulkImport: any = createAsyncThunk(
  `${config.name}/staff-bulk-import`,
  async (file: any) => {
    return Client.post(API_STAFF_BULK_IMPORT, file);
  }
);

export const deleteStaff: any = createAsyncThunk(
  `${config.name}/delete-staff`,
  async (staffId: string) => {
    return Client.delete(API_DELETE_STAFF+`${staffId}`);
  }
);

export const approveStaff: any = createAsyncThunk(
  `${config.name}/approve-staff`,
  async (staffId: string) => {
    return Client.patch(API_APPROVE_STAFF + `${staffId}`, {});
  }
);

export const rejectStaff: any = createAsyncThunk(
  `${config.name}/reject-staff`,
  async (staffId: string) => {
    return Client.patch(API_REJECT_STAFF + `${staffId}`, {});
  }
);

export const getStaffLopList: any = createAsyncThunk(
  `${config.name}/get-staff-lop-list`,
  async (body: any) => {
    return Client.post(API_GET_STAFF_LOP_LIST, body);
  }
);

export const upsertStaffLop: any = createAsyncThunk(
  `${config.name}/upsert-staff-lop`,
  async (body: any) => {
    return Client.post(API_UPSERT_STAFF_LOP, body);
  }
);
export const updateStaffById: any = createAsyncThunk(
  `${config.name}/update-staff`,
  async ({ staffId, formData }: { staffId: string, formData: FormData }) => {
    const url = API_UPDATE_STAFF + `${staffId}`;
    return Client.put(url, formData
    //   , 
    //   {
    //   // headers: {
    //   //   'Content-Type': 'multipart/form-data',
    //   // },
    // }
  );
  }
);

export const getAllStaffList: any = createAsyncThunk(
  `${config.name}/get-staff-list`,
  async () => {
    return Client.get(API_GET_ALL_STAFF_LIST);
  }
);

export const createStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/create-staff-salary`,
  async (body: any) => {
    const result = await Client.post(API_CREATE_STAFF_SALARY_INFO ,body);
    return result?.data;
  }
);

export const getStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/get-staff-salary`,
  async (staffId: string) => {
    const result = await Client.get(API_GET_STAFF_SALARY_INFO + `${staffId}`);
    return result?.data;
  }
);

export const updateStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/update-staff-salary`,
  async ({id,body} :{id: string, body:any}) => {
    const url = API_UPDATE_STAFF_SALARY_INFO + `${id}`;
    const result = await Client.put(url ,body);
    return result?.data;
  }
);

export const staffReducer = createSlice({
  name: config.name,
  initialState: {
    loadingStaff: false as any,
    staffList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetStaff: (state) => {
      state.loadingStaff = false;
      state.staffList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
    .addCase(getStaffList.pending, (state) => {
      state.loadingStaff = true;
      state.staffList = [] as any;
    })
    .addCase(getStaffList.fulfilled, (state, action) => {
      state.loadingStaff = false;
      state.staffList = action?.payload?.data as any;
      state.pagination = {page: action?.payload?.page, limit: action?.payload?.limit, total: action?.payload?.total}
    })
    .addCase(getStaffList.rejected, (state) => {
      state.loadingStaff = false;
      state.staffList = [] as any;
    })
  },
});

export const updateStaff = createAsyncThunk(
  "staff/updateStaff",
  async ({ id, body }: { id: string; body: any }, { rejectWithValue }) => {
    try {
      const response = await Client.put(`${API_UPDATE_STAFF}${id}`, body);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

// ... other thunks and slice definition




export const { resetStaff } = staffReducer.actions;
export default staffReducer.reducer;

